import React, { Component } from 'react';
import { Row, Col, FormControl, FormGroup, Badge, Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './AdvancedNotifications.css';
import SwitchButton from '../../Common/Switch/SwitchButton';

class FilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            segmentName: ''
        };
    }

    handleFilterChange = (category, field, value) => {
        const { filters, onFilterChange } = this.props;

        if (category === 'direct') {
            onFilterChange(field, value);
        } else {
            const updatedCategory = {
                ...filters[category],
                [field]: value
            };
            onFilterChange(category, updatedCategory);
        }
    }

    handleSaveSegment = () => {
        const { segmentName } = this.state;
        const { onSaveSegment } = this.props;
        
        if (segmentName.trim()) {
            onSaveSegment(segmentName);
            this.setState({ segmentName: '' });
        } else {
            alert('Please enter a segment name');
        }
    }

    renderActiveFilters = () => {
        const { filters } = this.props;
        const activeFilters = [];
        
        // Check user type
        if (filters.userType !== 'all') {
            activeFilters.push({
                label: filters.userType === '1' ? 'Riders' : filters.userType === '2' ? 'Drivers' : 'All Users',
                category: 'userType'
            });
        }
        
        // Check platform
        if (filters.platform !== 'all') {
            activeFilters.push({
                label: filters.platform === 'ios' ? 'iOS' : 'Android',
                category: 'platform'
            });
        }

        // Check activity filters
        if (filters.activity.lastLoginDays) {
            activeFilters.push({
                label: `Active in last ${filters.activity.lastLoginDays} days`,
                category: 'activity'
            });
        }
        
        if (filters.activity.isOnline) {
            activeFilters.push({
                label: 'Currently Online',
                category: 'activity'
            });
        }
        
        return activeFilters;
    }

    render() {
        const { filters } = this.props;
        const { segmentName } = this.state;
        const activeFilters = this.renderActiveFilters();

        return (
            <div className={s.filterPanel}>
                <Row>
                    <Col xs={12}>
                        <h4 className={s.filterTitle}>Smart Filters</h4>
                    </Col>
                </Row>

                {/* Active Filters Display */}
                {activeFilters.length > 0 && (
                    <Row className={s.activeFiltersRow}>
                        <Col xs={12}>
                            <div className={s.activeFilters}>
                                <span className={s.activeFiltersLabel}>Active Filters:</span>
                                {activeFilters.map((filter, index) => (
                                    <Badge key={index} bg="info" className={s.filterBadge}>
                                        {filter.label}
                                    </Badge>
                                ))}
                            </div>
                        </Col>
                    </Row>
                )}

                {/* Basic Filters */}
                <Row className={s.filterRow}>
                    <Col xs={12} md={4}>
                        <FormGroup>
                            <label className={s.filterLabel}>User Type</label>
                            <FormControl
                                as="select"
                                value={filters.userType}
                                onChange={(e) => this.handleFilterChange('direct', 'userType', e.target.value)}
                                className={s.filterSelect}
                            >
                                <option value="all">All Users</option>
                                <option value="1">Riders Only</option>
                                <option value="2">Drivers Only</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    
                    <Col xs={12} md={4}>
                        <FormGroup>
                            <label className={s.filterLabel}>Platform</label>
                            <FormControl
                                as="select"
                                value={filters.platform}
                                onChange={(e) => this.handleFilterChange('direct', 'platform', e.target.value)}
                                className={s.filterSelect}
                            >
                                <option value="all">All Platforms</option>
                                <option value="android">Android Only</option>
                                <option value="ios">iOS Only</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                </Row>

                {/* Activity Filters */}
                <Row className={s.filterRow}>
                    <Col xs={12}>
                        <h5 className={s.filterSectionTitle}>📊 Activity Filters</h5>
                    </Col>
                    <Col xs={12} md={3}>
                        <FormGroup>
                            <label className={s.filterLabel}>Last Active</label>
                            <FormControl
                                as="select"
                                value={filters.activity.lastLoginDays || ''}
                                onChange={(e) => this.handleFilterChange('activity', 'lastLoginDays', e.target.value ? Number(e.target.value) : null)}
                                className={s.filterSelect}
                            >
                                <option value="">Any Time</option>
                                <option value="1">Today</option>
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                                <option value="90">Last 90 days</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    
                    <Col xs={12} md={3}>
                        <FormGroup>
                            <label className={s.filterLabel}>Registration Date</label>
                            <FormControl
                                as="select"
                                value={filters.activity.registeredDays || ''}
                                onChange={(e) => this.handleFilterChange('activity', 'registeredDays', e.target.value ? Number(e.target.value) : null)}
                                className={s.filterSelect}
                            >
                                <option value="">Any Time</option>
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                                <option value="90">Last 90 days</option>
                                <option value="365">Last year</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    
                    <Col xs={12} md={3}>
                        <FormGroup>
                            <label className={s.filterLabel}>Trip History</label>
                            <FormControl
                                as="select"
                                value={filters.activity.hasCompletedTrip === null ? '' : filters.activity.hasCompletedTrip.toString()}
                                onChange={(e) => this.handleFilterChange('activity', 'hasCompletedTrip', e.target.value === '' ? null : e.target.value === 'true')}
                                className={s.filterSelect}
                            >
                                <option value="">Any</option>
                                <option value="true">Has completed trips</option>
                                <option value="false">Never taken a trip</option>
                            </FormControl>
                        </FormGroup>
                    </Col>
                    
                    {filters.userType === '2' && (
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <label className={s.filterLabel}>Currently Online</label>
                                <div style={{ marginTop: '8px' }}>
                                    <SwitchButton
                                        checked={filters.activity.isOnline}
                                        onChange={(checked) => this.handleFilterChange('activity', 'isOnline', checked)}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                    />
                                </div>
                            </FormGroup>
                        </Col>
                    )}
                </Row>

                {/* Behavior Filters */}
                <Row className={s.filterRow}>
                    <Col xs={12}>
                        <h5 className={s.filterSectionTitle}>💳 Behavior Filters</h5>
                    </Col>

                    {/* Payment Method - Only for Riders */}
                    {filters.userType === '1' && (
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <label className={s.filterLabel}>Payment Method</label>
                                <FormControl
                                    as="select"
                                    value={filters.behavior.hasPaymentMethod === null ? '' : filters.behavior.hasPaymentMethod.toString()}
                                    onChange={(e) => this.handleFilterChange('behavior', 'hasPaymentMethod', e.target.value === '' ? null : e.target.value === 'true')}
                                    className={s.filterSelect}
                                >
                                    <option value="">Any</option>
                                    <option value="true">Has payment method</option>
                                    <option value="false">No payment method</option>
                                </FormControl>
                            </FormGroup>
                        </Col>
                    )}

                    {/* Minimum Rating - Always visible */}
                    <Col xs={12} md={3}>
                        <FormGroup>
                            <label className={s.filterLabel}>Minimum Rating</label>
                            <FormControl
                                type="number"
                                min="1"
                                max="5"
                                step="0.5"
                                value={filters.behavior.minRating || ''}
                                onChange={(e) => this.handleFilterChange('behavior', 'minRating', e.target.value ? Number(e.target.value) : null)}
                                className={s.filterInput}
                                placeholder="e.g., 4.5"
                            />
                        </FormGroup>
                    </Col>

                    {/* Verification Status - Only for Drivers */}
                    {filters.userType === '2' && (
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <label className={s.filterLabel}>Verification Status</label>
                                <FormControl
                                    as="select"
                                    value={filters.behavior.isVerified === null ? '' : filters.behavior.isVerified.toString()}
                                    onChange={(e) => this.handleFilterChange('behavior', 'isVerified', e.target.value === '' ? null : e.target.value === 'true')}
                                    className={s.filterSelect}
                                >
                                    <option value="">Any</option>
                                    <option value="true">Verified</option>
                                    <option value="false">Not Verified</option>
                                </FormControl>
                            </FormGroup>
                        </Col>
                    )}
                </Row>

                {/* Save Segment */}
                <Row className={s.saveSegmentRow}>
                    <Col xs={12} md={6}>
                        <div className={s.saveSegmentWrapper}>
                            <FormControl
                                type="text"
                                placeholder="Enter segment name (e.g., 'Riders Registered Last 7 Days')"
                                value={segmentName}
                                onChange={(e) => this.setState({ segmentName: e.target.value })}
                                className={s.segmentNameInput}
                            />
                            <Button 
                                variant="outline-primary"
                                onClick={this.handleSaveSegment}
                                className={s.saveSegmentButton}
                            >
                                Save Segment
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withStyles(s)(FilterPanel);